// @flow

import * as React from "react";
import qb_sign_in_button_med from "../images/qb_sign_in_button_med.svg"
import logo from "../images/logo.svg"
import {ShieldIcon} from "./Icons.react";
import {loginErrorFromLocation} from "../Utils";
import AppFooter from "./AppFooter.react";
import {INTUIT_SECURITY_URL} from "../Constants";

// Shown under the email_unverified notice: a common reason people can't sign in, and Intuit's own error doesn't say how
// to fix it. The "Verify email" button is on the security page of the Intuit account manager.
function VerifyIntuitEmailSteps() {
  return (
    <ol style={{margin: "8px 0 0", paddingLeft: "18px", color: "#232b3d"}}>
      <li>Open your{" "}
        <a href={INTUIT_SECURITY_URL} target="_blank" rel="noopener noreferrer"
           style={{textDecoration: "underline", fontWeight: 700}}>Intuit account security page</a>{" "}
        and sign in with your QuickBooks email and password if asked.</li>
      <li>Click <b>Verify email</b>.</li>
      <li>Open the email Intuit sends you and click the verification link.</li>
      <li>Come back to this page and click <b>Sign in with Intuit</b> again.</li>
    </ol>
  );
}

class Login extends React.Component {

  render() {
    // ?error= carries a code only; loginErrorFromLocation maps it to our own text (never shows the URL's text).
    const notice = loginErrorFromLocation(this.props.location);

    return (
        <div style={{
          minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
          padding: "24px", background: "linear-gradient(160deg, #f5f8f4 0%, #f7f9fb 45%, #f7f9fb 100%)",
        }}>
          <div style={{width: "400px", maxWidth: "100%"}}>
            {notice ? (
              <div style={{
                display: "flex", alignItems: "flex-start", gap: "10px",
                background: notice.isInfo ? "#eef2f6" : "#fdecec",
                border: "1px solid " + (notice.isInfo ? "#d5dbe3" : "#f5c6c6"),
                color: notice.isInfo ? "#232b3d" : "#c92a2a", borderRadius: "10px",
                padding: "12px 14px", marginBottom: "16px", fontSize: "0.85rem", lineHeight: 1.4,
              }}>
                {notice.isInfo ? null : <span style={{fontSize: "1rem"}}>⚠</span>}
                <div>
                  <span>{notice.text}</span>
                  {notice.code === "email_unverified" ? <VerifyIntuitEmailSteps /> : null}
                </div>
              </div>
            ) : null}

            <div className="app-card" style={{
              textAlign: "center", padding: "40px 32px 32px",
              boxShadow: "0 20px 45px rgba(35, 43, 61, 0.08)", border: "1px solid #edf0f3",
            }}>
              <div style={{margin: "0 auto 20px"}}>
                {/* logo.svg carries "formerly QRify" under the wordmark: existing customers still know the old name. */}
                <img src={logo} style={{height: "53px"}} alt="Scan2Pay, formerly QRify" />
              </div>

              <h1 style={{fontSize: "1.25rem", fontWeight: 700, margin: "0 0 8px"}}>Welcome back</h1>
              <p style={{color: "#8892a0", fontSize: "0.9rem", lineHeight: 1.5, margin: "0 0 28px"}}>
                Sign in with your QuickBooks account to generate and manage QR invoices.
              </p>

              <a href={window.SERVER_URL + '/sso/login'} style={{display: "inline-block"}}>
                <img src={qb_sign_in_button_med} alt="Sign in with Intuit" style={{display: "block"}} />
              </a>

              <div style={{
                display: "flex", alignItems: "center", justifyContent: "center", gap: "6px",
                marginTop: "28px", paddingTop: "20px", borderTop: "1px solid #f0f2f5",
                color: "#b7bec9", fontSize: "0.78rem",
              }}>
                <ShieldIcon size={13} />
                <span>Secure sign-in, powered by Intuit</span>
              </div>
            </div>

            <AppFooter />
          </div>
        </div>
    );
  }
}

export default Login;
